import { useCallback } from 'react';
import ContentLoader from 'react-content-loader';
import NoRecordLogo from '../../../assets/logo/No_record_logo.png';
import Paginate from '../../../components/Paginate';
import { useDict } from '../../../contexts/LanguageContext';
import useWindowSize from '../../../hooks/useWindowSize';
import { BootstrapBreakpoints } from '../../../utils/constants';
import CompletedInvestmentNoteCardList from './CompletedInvestmentNoteCardList';

const ListHistory = (props) => {
    const dict = useDict();

    const {
        investmentNotes,
        pageCount,
        page,
        setPage,
        isFetching,
        doTermLoanModal,
        onShowComment,
    } = props;

    const { width } = useWindowSize();
    const isMobile = width <= BootstrapBreakpoints.SM;

    const onPageChange = useCallback((event) => {
        setPage(event.selected + 1);
    }, []);

    const renderList = () => {
        if (isFetching) {
            return [...Array(3)].map(() => (
                <ContentLoader
                    width="100%"
                    height="150"
                    gradientDirection="top-bottom"
                    backgroundColor="#eee"
                    foregroundOpacity={0.3}
                    className="mb-4"
                >
                    <rect width="100%" height="100%" y="0" rx="10" ry="10" />
                </ContentLoader>
            ));
        }

        if (
            investmentNotes &&
            investmentNotes?.length > 0
        ) {
            return (
                <CompletedInvestmentNoteCardList
                    investmentNotes={investmentNotes}
                    doTermLoanModal={doTermLoanModal}
                    onShowComment={onShowComment}
                />
            );
        }
        return (
            <div className="d-flex flex-column align-items-center mt-4 mb-4">
                <img
                    src={NoRecordLogo}
                    alt="noRecord"
                    style={{
                        width: isMobile ? '60%' : '30%',
                        objectFit: 'contain',
                        minHeight: isMobile ? '20vh' : undefined,
                    }}
                />
                <p className="mt-3 font-size-20">{dict.comingSoon}</p>
            </div>
        );
    };

    return (
        <>
            {renderList()}
            {
                pageCount > 1 && (
                    <Paginate
                        pageCount={pageCount}
                        onPageChange={onPageChange}
                        forcePage={page - 1}
                    />
                )
            }
        </>
    );
};

export default ListHistory;
